import { loadMetrika } from "./metrika.js";

/** Ключ решения читателя. Значение хранится с первой версии баннера, не менять. */
const CONSENT_KEY = "cookieConsent";

/** Кнопка плашки: разметку задаёт класс компонента, а не инлайновый стиль. */
function button(label, variant) {
  const element = document.createElement("button");
  element.type = "button";
  element.className = `btn btn--${variant} btn--sm`;
  element.textContent = label;
  return element;
}

function readChoice() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    // Приватный режим или запрет на хранилище: спросим ещё раз в другой заход.
    return null;
  }
}

function saveChoice(choice) {
  try {
    localStorage.setItem(CONSENT_KEY, choice);
  } catch {
    // Не запомнили — спросим в следующий раз.
  }
}

/**
 * Стирает cookie Метрики (`_ym_*`) после отказа.
 *
 * Метрика ставит их на домен сайта; без этого отозванное согласие оставило бы
 * идентификатор жить ещё год.
 */
function clearMetrikaCookies() {
  const domains = ["", location.hostname, `.${location.hostname}`];
  for (const entry of document.cookie.split(";")) {
    const name = entry.split("=")[0].trim();
    if (!name.startsWith("_ym")) continue;
    for (const domain of domains) {
      const scope = domain ? `; domain=${domain}` : "";
      document.cookie = `${name}=; max-age=0; path=/${scope}`;
    }
  }
}

/**
 * Плашка согласия на cookie.
 *
 * Необходимые cookie (вход, защита форм) работают всегда — для них согласие
 * не спрашивают. Спрашиваем про Яндекс.Метрику: она подключается только после
 * «Разрешить», до ответа внешних скриптов на странице нет. Плашка намеренно
 * маленькая, в углу экрана, и не мешает читать страницу.
 */
function showBanner() {
  document.getElementById("cookie-consent")?.remove();

  const banner = document.createElement("div");
  banner.id = "cookie-consent";
  banner.className = "cookie-consent";
  banner.setAttribute("role", "region");
  banner.setAttribute("aria-label", "Согласие на cookie");
  // Иначе плашка попадёт в снапшот Turbo и вернётся на уже отвеченной странице.
  banner.dataset.turboTemporary = "";

  const text = document.createElement("p");
  text.className = "cookie-consent__text";
  text.append("Cookie для входа сайту нужны всегда. Яндекс.Метрику для статистики посещений включим, только если разрешите. ");
  const more = document.createElement("a");
  more.href = "/cookie-policy/";
  more.textContent = "Подробнее";
  text.append(more);

  const actions = document.createElement("div");
  actions.className = "cookie-consent__actions";
  const accept = button("Разрешить", "primary");
  const decline = button("Отклонить", "outline");
  actions.append(accept, decline);

  banner.append(text, actions);
  document.body.append(banner);

  accept.addEventListener("click", () => {
    saveChoice("accepted");
    banner.remove();
    loadMetrika();
  });

  decline.addEventListener("click", () => {
    const wasAccepted = readChoice() === "accepted";
    saveChoice("declined");
    banner.remove();
    clearMetrikaCookies();
    // Счётчик уже работает на этой странице — выгрузить его можно только перезагрузкой.
    if (wasAccepted) location.reload();
  });
}

(function () {
  const choice = readChoice();
  if (choice === "accepted") loadMetrika();
  else if (choice !== "declined") showBanner();

  // «Настройки cookie» в подвале: решение можно поменять в любой момент.
  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-cookie-settings]")) return;
    event.preventDefault();
    showBanner();
  });
})();
